/*
 * @author Maksym Shutiak <maxshutyak>
 */
const gccsPlanningTutorialEmployee = {
  template: require('./template.pug')
};

angular.module('public.security-manager.schedule-manager.timeline.planning')
  .component('gccsPlanningTutorialEmployee', gccsPlanningTutorialEmployee);
